import type { DataTablePage } from "../components/dataTable/dataTable.types";

interface PaginatedResponse<TData> {
  data: TData[];
  page: { total_items: number };
}

export function selectPaginatedPage<TData>(
  response: PaginatedResponse<TData>,
): DataTablePage<TData> {
  return { rows: response.data, rowCount: response.page.total_items };
}
